/**
 * LEAVE THE VALUES, IT MUST BE SET EXPLICITLY.
 */
export enum PaymentTypesEnum {
  PAY = 0,
  REGISTER = 1,
  COMMIT = 2,
  TX_APPROVAL = 3,
  TX_TRANSFER = 4,
  TX_RENEW = 5,
  TX_SET_ENS_NAME = 6,
  TX_SET_ENS_CONTENT_HASH = 7,
  TX_SET_ENS_TEXT = 8,
}
